import { FocusLock as ChakraFocusLock } from '@chakra-ui/react'

import { FocusLockProps } from './FocusLock.types'

export default function FocusLock(props: FocusLockProps) {
  return <ChakraFocusLock {...props} />
}
